import { localStorage } from 'conversations-platform/localStorage';
export const clearDraft = draftKey => {
  try {
    localStorage.removeItem(draftKey);
  } catch (error) {
    //
  }
};